/**
 * @generated SignedSource<<c336afd15c7a46d43506bdb774c29242>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type useWidgetTeamScheduleSubscriptionIssueCreateSubscription$variables = {
  teamId: string;
};
export type useWidgetTeamScheduleSubscriptionIssueCreateSubscription$data = {
  readonly issueCreated: {
    readonly taskExecution: {
      readonly routineOccasion: {
        readonly id: string;
        readonly issueCount: number;
      };
    };
  } | null;
};
export type useWidgetTeamScheduleSubscriptionIssueCreateSubscription = {
  response: useWidgetTeamScheduleSubscriptionIssueCreateSubscription$data;
  variables: useWidgetTeamScheduleSubscriptionIssueCreateSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamId"
  }
],
v1 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "teamIds.0",
        "variableName": "teamId"
      }
    ],
    "kind": "ListValue",
    "name": "teamIds"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "RoutineOccasion",
  "kind": "LinkedField",
  "name": "routineOccasion",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "issueCount",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useWidgetTeamScheduleSubscriptionIssueCreateSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Issue",
        "kind": "LinkedField",
        "name": "issueCreated",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "taskExecution",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useWidgetTeamScheduleSubscriptionIssueCreateSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Issue",
        "kind": "LinkedField",
        "name": "issueCreated",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "taskExecution",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "080e39818ff9430f3e462c7eaeac88fd",
    "id": null,
    "metadata": {},
    "name": "useWidgetTeamScheduleSubscriptionIssueCreateSubscription",
    "operationKind": "subscription",
    "text": "subscription useWidgetTeamScheduleSubscriptionIssueCreateSubscription(\n  $teamId: ID!\n) {\n  issueCreated(teamIds: [$teamId]) {\n    taskExecution {\n      __typename\n      routineOccasion {\n        id\n        issueCount\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "ce6c01ae17540d15ba02f8c0157d9f24";

export default node;
